import React, {Component} from 'react';
//image
import vuepay_large_logo from '../assets/images/vuepaylogonav@5x.png';
import * as animationData from '../assets/lottie/preview_icon_hover.json'

import Animation from "../components/Animation";
import * as actions from "../actions";
import {connect} from "react-redux";

class NoMatch extends Component {

    componentDidMount() {
        this.props.hideLeftBar(); //hide the leftbar
        window.location.href = "/";
    }

    render() {

        return (
            <div>
                <main role="main" className="">
                    <input type="hidden" value="something"/>
                    <div className="login-container" style={{display:'none'}}>
                        <div className="row">
                            <div className="col-md-6 bg-primary d-flex align-items-center text-center"
                                 style={{borderRight: '1px solid #e7e7e7'}}>
                                <img src={vuepay_large_logo} className="img-fluid" alt={"VuePay logo"}/>
                            </div>
                            <div className="col-md-6 bg-white d-flex align-items-center">
                                <Animation animationData={animationData} width={500} height={500}>
                                    <div className="text-align-center black">
                                        The page you are looking for is not found
                                    </div>
                                </Animation>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps, actions)(NoMatch);